module.exports = __webpack_public_path__ + "img/icjia-logo-white.36ec2e16.png";